<template>
  <div class="d-flex">
    <pa-user-avatar
      v-for="user in projectUsers.slice(0, usersToShow)"
      :key="user.id"
      :image="user.profile.photoURL"
      :name="user.profile.displayName"
      :size="36"
      type="avatar"
    />

    <div
      v-if="projectUsers.length > usersToShow"
      class="align-self-center ml-2"
    >
      +{{ projectUsers.length - usersToShow }}
    </div>

    <v-spacer />

    <v-menu
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on: menu }">
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              color="primary"
              icon
              v-on="{ ...tooltip, ...menu }"
            >
              <v-icon>person_add</v-icon>
            </v-btn>
          </template>

          <span v-t="'projects.team.addUser'" />
        </v-tooltip>
      </template>

      <pa-user-picker
        solo
        @input="onUserPicked"
      />
    </v-menu>

    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          color="primary"
          :href="`mailto:${projectUsers.map(u => u.email).join(', ')}`"
          :disabled="projectUsers.length === 0"
          target="_blank"
          v-on="on"
        >
          <v-icon>email</v-icon>
        </v-btn>
      </template>

      <span v-t="'projects.team.sendEmail'" />
    </v-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    project: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      usersToShow: 4
    }
  },
  computed: {
    ...mapGetters([ 'getUserById' ]),
    projectUsers () {
      return this.project.users.map(this.getUserById)
    }
  },
  methods: {
    onUserPicked (user) {
      this.project.users.push(user)
      this.project.save()
    },
    deleteUser (user) {
      const i = this.project.users.indexOf(user)
      if (i > -1) {
        this.project.users.splice(i, 1)
        this.project.save()
      }
    }
  }
}
</script>

<style>

</style>
